// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__1MQN3","header":"App_header__3ZZ1n","logo":"App_logo__1ItuU","sidePane":"App_sidePane__3RleR","main":"App_main__3ZkGI"};